import React from "react";
import { ValidationErrorMessage } from "react-admin";
import { Controller, FieldValues } from "react-hook-form";
import { EventPicker } from "../../EventPicker/EventPicker";
import { HookFormInputProps } from "./HookFormInputProps";

interface Props<TRecord> extends HookFormInputProps<TRecord> {
  margin?: "none" | "dense" | "normal";
  variant?: "standard" | "outlined" | "filled";
  initialDate?: Date;
  driverId: number;
  timeZone?: string;
}

const HookFormEventPickerComponent = <TRecord extends FieldValues>(
  {
    control,
    name,
    defaultValue,
    label,
    rules,
    margin,
    variant,
    options,
    initialDate,
    driverId,
    timeZone,
  }: Props<TRecord>,
  ref: React.Ref<HTMLDivElement>
) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue ?? ""}
      rules={rules}
      render={(renderProps) => (
        <EventPicker
          driverId={driverId}
          initialDate={initialDate}
          label={label}
          margin={margin}
          variant={variant}
          options={options}
          timeZone={timeZone}
          {...renderProps.field}
          touched={renderProps.fieldState.isTouched}
          error={
            (renderProps.fieldState.error as any)
              ?.message as ValidationErrorMessage
          }
          helperText={(renderProps.fieldState.error as any)?.message as string}
          inputRef={renderProps.field.ref}
        />
      )}
    />
  );
};

export const HookFormEventPicker = React.forwardRef(
  HookFormEventPickerComponent
);
